module.exports = __webpack_public_path__ + "static/media/cart-icon.d114e2ad.svg";